export default "__VITE_ASSET__BUClQTEq__"